export default "__VITE_ASSET__9570523a__$_?component__"